'use strict';
const Ajax = require('common/infra/ajax');
const $ = require('jquery');

class API {
    constructor() {
    }

    getUploadURL(projectID) {
        const path = `/api/projects/${projectID}/storage-objects`;
        return Ajax.POST(path)
    }

    getDownloadURL(projectID, storageObjectId) {
        return `/api/projects/${projectID}/storage-objects/${storageObjectId}`;
    }
}

module.exports = new API();


// WEBPACK FOOTER //
// ./data/infra/api/storage/index.js